import { useParams } from "react-router-dom";
import { PoDetailsEditVendorContainer } from "./container";

export const PoDetailsEditVendorPane = () => {
  const params = useParams();
  const { vendor } = params;
  return vendor ? <PoDetailsEditVendorContainer id={vendor} /> : <></>;
};
